var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons/bin"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3942",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 24,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0989 3H13.8995C12.0362 3 10.4697 4.27505 10.0253 5.99993H6.9997C5.61862 5.99993 4.5 7.11965 4.5 8.5007L4.50799 8.69252C4.61389 9.81118 5.39662 10.686 6.41504 10.9313L8.38634 25.7141C8.63706 27.5952 10.2415 29 12.1391 29H19.8595C21.7572 29 23.3626 27.5951 23.6133 25.714L25.5835 10.9318C26.6824 10.6686 27.499 9.67985 27.499 8.5007L27.491 8.30876C27.3657 6.98316 26.291 5.99993 24.9993 5.99993H21.9732C21.5289 4.27488 19.9629 3 18.0989 3ZM24.9993 9.0004H6.9997C6.74178 9.0004 6.52656 8.80359 6.50233 8.54994L6.49887 8.45323C6.5 8.22378 6.72363 7.99993 6.9997 7.99993H9.89903V8.00047H22.0993V7.99993H24.9993C25.2573 7.99993 25.4724 8.19675 25.4967 8.45117L25.5001 8.54811C25.499 8.77661 25.2753 9.0004 24.9993 9.0004ZM10.3688 25.4498L8.44105 11.0004H23.5559L21.6308 25.4498C21.5126 26.337 20.755 27 19.8595 27H12.1391L11.9827 26.9932C11.1571 26.9213 10.4801 26.2851 10.3688 25.4498ZM19.83 5.99993L19.7771 5.91128C19.4458 5.40195 18.889 5.05277 18.2482 5.00549L18.0989 5H13.8995C13.1968 5 12.5783 5.36295 12.2215 5.91146L12.168 5.99993H19.83ZM16.9927 13.4837C16.9349 12.9864 16.5122 12.6003 15.9994 12.6003C15.4471 12.6003 14.9994 13.048 14.9994 13.6003V24.4001L15.0061 24.5167C15.0639 25.014 15.4866 25.4001 15.9994 25.4001C16.5517 25.4001 16.9994 24.9524 16.9994 24.4001V13.6003L16.9927 13.4837ZM11.6673 13.8091C12.1757 13.7413 12.6456 14.0681 12.7686 14.5534L12.7907 14.6681L13.9907 23.6685C14.0637 24.2159 13.6791 24.7189 13.1316 24.7919C12.6233 24.8596 12.1533 24.5328 12.0303 24.0475L12.0082 23.9328L10.8083 14.9324C10.7353 14.385 11.1199 13.8821 11.6673 13.8091ZM21.1993 14.816C21.2077 14.3154 20.8398 13.8768 20.3315 13.8091L20.215 13.8003C19.7144 13.7919 19.2758 14.1598 19.2081 14.6681L18.0081 23.6685L17.9994 23.785C17.9909 24.2856 18.3588 24.7241 18.8672 24.7919C19.4146 24.8648 19.9176 24.4802 19.9906 23.9328L21.1905 14.9324L21.1993 14.816Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/secondary/lightCyan+75 Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 11",
    width: 32,
    height: 32,
    fill: "black",
    fillOpacity: 0.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin1X);
export default __webpack_public_path__ + "static/media/bin@1x.940994ae705bdb859ea3e94af99b41a4.svg";
export { ForwardRef as ReactComponent };